import React from 'react';
import { Route, Switch, NavLink, Redirect } from 'react-router-dom';//Link, 
import Login from './Login';
import { RequestPasswordReset } from './RequestPasswordReset';
import { Welcome } from './Welcome';
import ResetPassword from './ResetPassword';
import { session } from '../authentication';
import tbLogoOrange from '../assets/tbLogoOrange.png';

export const AnonLayout = () => {
    let user = session.getUser();
    if (user) return <Redirect to="/Projects" />
    else  return (
        <div className="anon">
            <nav className="navbar navbar-default navbar-fixed-top container-fluid">
                <div className="navbar-header fix-top-left">
                    <NavLink to={`/Projects`} className="navbar-brand anon">
                        <img alt="Truebyte" src={tbLogoOrange} />
                    </NavLink>
                </div>
                <div className="sidebar-offset">
                    <ul className="nav navbar-nav navbar-right mr-0">
                        <li className="dropdown">
                            <NavLink to="/Login">Log in</NavLink>
                        </li>
                    </ul>
                </div>
            </nav>
            <div className="container-fluid mt-lg">
                <Switch>
                    <Route exact={true} path="/" component={Welcome} />
                    <Route exact={true} path="/Login" component={Login} />
                    <Route exact={true} path="/ForgotPassword" component={RequestPasswordReset} />
                    <Route exact={true} path="/ResetPassword/:user" component={ResetPassword} />
                </Switch>                
            </div>
        </div>)
}